/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { CHANGE_USERNAME,SET_HISTORY_DATA, ON_CALL_UPLOAD, PASS_INV_VAL, RESET_FETCH_PASS, ON_NOTIFY, LOADER_STATUS, TOTAL_RECORD, GET_ITEM, TOTAL_ITEM_RECORDS, TXN_RECORD, DISABLE_EDIT, SET_PASS_PAGE, EXTEND_DATA, GET_DATA, FETCH_COLUMNS} from './constants';

// The initial state of the App
export const initialState = {
  username: '',
  uploadData: '',
  passData: '',
  status: false,
  msg: '',
  loaderStatus: false,
  totalRecords: '',
  itemData: '',
  totalItemRecord: '',
  propsTxnId: '',
  nonEdit: [],
  passPage: 1,
  records: '',
  extendDataVal: '',
  getDataVal: '',
  setColumnsVal: '',
  historyTableData:[],
};

/* eslint-disable default-case, no-param-reassign */
const ewayBillGetCallReducer = (state = initialState, action) =>{
    switch (action.type) {
      case CHANGE_USERNAME:
        return {
          ...state,
          username:action.username.replace(/@/gi, '')
        }
      case ON_CALL_UPLOAD:
        return {
          ...state,
          uploadData:action.uploadData
        }
      case PASS_INV_VAL:
        return {
          ...state,
          passData:action.passData
        }
      case RESET_FETCH_PASS:
        return {
          ...state,
          passData:action.passData
        }
      case ON_NOTIFY:
        return {
          ...state,
          status:action.status,
          msg:action.msg
        }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case TOTAL_RECORD:
        return {
          ...state,
          totalRecords:action.totalRecords,
          records:action.records
        }
      case GET_ITEM:
        return {
          ...state,
          itemData:action.itemData
        }
      case TOTAL_ITEM_RECORDS:
        return {
          ...state,
          totalItemRecord:action.totalItemRecord
        }
      case TXN_RECORD:
        return {
          ...state,
          propsTxnId:action.propsTxnId
        }
      case DISABLE_EDIT:
        return {
          ...state,
          nonEdit:action.nonEdit
        }
      case SET_PASS_PAGE: 
        return {
          ...state,
          passPage:action.passPage
        }
      case EXTEND_DATA:
        return {
          ...state,
          extendDataVal:action.extendDataVal
        }
      case GET_DATA:
        return {
          ...state,
          getDataVal:action.getDataVal
        }
      case FETCH_COLUMNS:
        return {
          ...state,
          setColumnsVal:action.setColumnsVal
        }
        case SET_HISTORY_DATA:
          return {
            ...state,
            historyTableData:action.historyTableData
          }
      default:
        return state;
    }
  };

export default ewayBillGetCallReducer;
